import variables from './vars';
import { start, connected$, notification$ } from '../../sockets/connection';
import { actionAfterNotification } from './pay';

let bbVars = new variables();


function assignConfig(serverConfig, localConfig) {
    bbVars.bbfConfig = Object.assign({}, serverConfig, localConfig);
}

let initConnection = () => {
    start(bbVars.bbUrlBase, bbVars.bbToken);
    connected$.subscribe(data => console.log('connected$: ', data));
    notification$.subscribe(data => actionAfterNotification(data));
}

export { bbVars, assignConfig, initConnection };